import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import messages_ja from "./translations/ja.json";
import messages_en from "./translations/en.json";
import { app_root_path } from "data/Spec";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import ListView from "./components/view/ListView.js";
import ChartFrame from "./components/chart/ChartFrame.js";
import Top from "components/Top";

const messages = {
  ja: messages_ja,
  en: messages_en,
};
var language = navigator.language.split(/[-_]/)[0]; // language without region code

if (!messages[language]) {
  language = "en";
}

class App extends Component {
  render() {
    return (
      <IntlProvider
        locale={language}
        messages={messages[language]}
        textComponent={React.Fragment}
      >
        <BrowserRouter basename={app_root_path}>
          <Routes>
            <Route index element={<Top />} />
            <Route path="/view" element={<Top />} />
            <Route path="/view/:listType" element={<ListView />} />
            <Route path="/chart/:listType" element={<ChartFrame />} />
            <Route path="/chart/:listType/:checkType" element={<ChartFrame />} />
          </Routes>
        </BrowserRouter>
      </IntlProvider>
    );
  }
}

export default App;
